document.addEventListener('turbolinks:load', function() {
  const tabIndexes = $('[tabindex]');
  tabIndexes.focus(function() {
    $(this).css('outline', 'none');
  });

  tabIndexes.keyup(function(e) {
    if (e.key === 'Tab') {
      $(this).css('outline', '');
    }
  });

  const anchorButtons = $('a[role="button"]');
  anchorButtons.keydown(function(e) {
    if (e.key === ' ') { e.preventDefault(); }
    if (e.key === 'Enter' || e.key === ' ') { $(this).click(); }
  });
});
